import { Link } from "wouter";
import { ArrowRight } from "lucide-react";
import { caseStudies } from "@/data/case-studies";

const tagStyles: Record<string, string> = {
  "Active Listening": "text-primary-text border-primary-text/40 bg-black/20",
  "Rapid Deploy": "text-orange-500 border-orange-500/40 bg-orange-500/10",
  "Restricted List": "text-primary-text border-primary-text/40 bg-black/20",
};

export function StakesSection() {
  return (
    <section className="pt-10 pb-24 md:py-24 border-b border-border/40 bg-accent/20 relative overflow-hidden">
      <div className="absolute top-0 right-0 w-[400px] h-[400px] bg-primary/5 rounded-full blur-3xl pointer-events-none" />
      <div className="container mx-auto px-0 md:px-6 relative z-10">
        <div className="text-center mb-16 px-6 md:px-0">
          <h2 className="text-4xl md:text-5xl font-bold tracking-tight mb-4">
            When the Stakes<br className="md:hidden" /> Are Highest
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            One platform — matched to whatever moment you’re in.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {caseStudies.map((c) => (
            <Link
              key={c.slug}
              href={`/case-studies/${c.slug}`}
              className="group p-8 border border-border/50 bg-card/50 flex flex-col gap-5 hover:border-primary/40 transition-colors"
            >
              <span
                className={`self-start text-xs font-semibold uppercase tracking-wider px-2 py-1 border ${tagStyles[c.product] ?? "text-primary-text border-primary-text/40 bg-black/20"}`}
              >
                {c.product}
              </span>
              <h3 className="text-xl font-bold leading-tight tracking-normal text-white">
                {c.card.title}
              </h3>
              <p className="text-sm text-muted-foreground leading-relaxed">
                {c.card.summary}
              </p>
              <div className="mt-auto pt-4 border-t border-border/40">
                <p className="text-sm font-semibold text-foreground mb-3">
                  {c.card.outcome}
                </p>
                <span aria-label={`Read case study: ${c.card.title}`} className="inline-flex items-center text-primary-text font-medium text-sm group-hover:underline">
                  Read case study
                  <ArrowRight className="ml-2 w-4 h-4 group-hover:translate-x-1 transition-transform" />
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
